import React from 'react'

// components shared with account manager
import Campers from 'components/account/Overview/Campers'
import Parents from 'components/account/Overview/Parents'
import EmergencyContacts from 'components/account/Overview/EmergencyContacts'
import PickupPeople from 'components/account/Overview/PickupPeople'

// local components
import NotCompleteWarning from './NotCompleteWarning'
import OrderSummary from './OrderSummary'
import Form from './Form'

// helpers
import { cartTotal } from 'lib/cart/decorators/cartForm'

const Confirm = props => {
  const {
    account, // via withQuery
    cartForm,
    enableCovidRequirements, // via withQuery
    sessions
  } = props

  const { preferences } = account || {}
  const { onlineOnly = true } = preferences || {}

  return (
    <>
      <NotCompleteWarning />
      <OrderSummary
        title='Order Summary'
        buttonText='Edit Order'
        buttonRoute='/cart'
        account={account}
        cartForm={cartForm}
        sessions={sessions}
      />

      <Campers
        title='Campers'
        buttonText='Edit Campers'
        buttonRoute='/campers'
        account={account}
      />

      <Parents
        title='Parents / Guardians'
        buttonText='Edit parents / guardians'
        buttonRoute='/parents'
        account={account}
      />

      {!onlineOnly && (
        <>
          <EmergencyContacts
            title='Emergency Contacts'
            buttonText='Edit emergency contacts'
            buttonRoute='/emergency_contacts'
            account={account}
          />

          <PickupPeople
            title='Pick-up People'
            buttonText='Edit pick-up people'
            buttonRoute='/pickup_people'
            account={account}
          />
        </>
      )}

      <Form
        account={account}
        onlineOnly={onlineOnly}
        enableCovidRequirements={enableCovidRequirements}
        total={cartTotal({
          account,
          cartForm,
          campers: account.campers,
          sessions
        })}
      />
    </>
  )
}

export default Confirm
